var map = {
	"./de.png": "./src/assets/post/workbooks/de.png",
	"./en.png": "./src/assets/post/workbooks/en.png",
	"./en2.png": "./src/assets/post/workbooks/en2.png",
	"./es.png": "./src/assets/post/workbooks/es.png",
	"./fr.png": "./src/assets/post/workbooks/fr.png",
	"./it.png": "./src/assets/post/workbooks/it.png",
	"./pt.png": "./src/assets/post/workbooks/pt.png",
	"./ru.png": "./src/assets/post/workbooks/ru.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/post/workbooks sync recursive ^\\.\\/.*\\.png$";